import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EnrollmentListShell from "../components/EnrollmentListShell";
import FiltersInlineSlot from "../components/FiltersInlineSlot";
import UserEnrollmentRow from "../components/UserEnrollmentRow";
import { usePreEnrolledUsersList } from "../hooks/usePreEnrolledUsersList";
import {
  buildEnrollTypeOptions,
  buildPreStatusOptions,
} from "../config/filterOptions";

const PAGE_SIZE = 10;

interface PreEnrolledUsersTabProps {
  corporateId: string | number;
  objectId: number;
}

const PreEnrolledUsersTab: React.FC<PreEnrolledUsersTabProps> = ({
  corporateId,
  objectId,
}) => {
  const { t } = useTranslation("users-and-groups");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [enrollType, setEnrollType] = useState("");

  const { items, totalItems, totalPages, isLoading } = usePreEnrolledUsersList({
    corporateId,
    objectId,
    page,
    pageSize: PAGE_SIZE,
    search: search || undefined,
    status: status || undefined,
    enrollType: enrollType || undefined,
  });

  // TODO: verificare le opzioni dei filtri Stato/Tipo per il tab Utenti Preiscritti.
  // V1 non espone questi filtri in UI (`hasFilter: false` in preregisteredUsers-config.json);
  // qui Stato (T/PW/PA) e Tipo (enrollType) sono stati introdotti per coerenza col mockup V2.
  return (
    <EnrollmentListShell
      search={search}
      onSearchSubmit={(v) => {
        setSearch(v);
        setPage(1);
      }}
      filtersSlot={
        <FiltersInlineSlot
          filters={[
            {
              id: "pre-enrolled-users-status",
              label: String(t("filters.status")),
              value: status,
              options: buildPreStatusOptions(t),
              onChange: (v) => {
                setStatus(v);
                setPage(1);
              },
            },
            {
              id: "pre-enrolled-users-type",
              label: String(t("filters.type")),
              value: enrollType,
              options: buildEnrollTypeOptions(t),
              onChange: (v) => {
                setEnrollType(v);
                setPage(1);
              },
            },
          ]}
        />
      }
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={String(t("empty.pre-enrolled-users"))}
      page={page}
      pageSize={PAGE_SIZE}
      totalItems={totalItems}
      totalPages={totalPages}
      onPageChange={setPage}
    >
      {items.map((user) => (
        <UserEnrollmentRow
          key={`${user.userId}-${user.enrollId ?? ""}`}
          user={user}
          onArrowClick={(u) => {
            // TODO: navigare al detail enrollment del singolo utente preiscritto
            console.log("[pre-enrolled-users] arrow click", u);
          }}
        />
      ))}
    </EnrollmentListShell>
  );
};

export default PreEnrolledUsersTab;
